define('areas/shopitemtemplate/commands/createshopitemscommand',["require", "exports", "services/navigator"], function (require, exports, Navigator) {
    "use strict";
    var CreateShopItemsCommand = (function () {
        function CreateShopItemsCommand() {
        }
        CreateShopItemsCommand.prototype.execute = function (template) {
            Navigator.navigateTo("shopitemtemplate", "createshopitems", "/template", null, [
                { key: "id", value: template.rowKey }
            ]);
        };
        return CreateShopItemsCommand;
    }());
    return CreateShopItemsCommand;
});

